const generateNotification = (type, group) => text => ({
  type,
  text,
  group,
});

module.exports = {
  error: generateNotification('error', 'error'),
  success: generateNotification('success', 'success'),
};



// WEBPACK FOOTER //
// ./src/helpers/notifications.js